import AdaptiveCriticalImage from "../../atoms/AdaptiveCriticalImage";
import TpWidgetMicro from "../common/TpWidgetMicro";
import { viewport } from "@styles/cssinjs/helpers/variables";
export default function Hero({ data }) {
  const appMode = process.env.APP_MODE;
  const signupLink = data?.cta?.link?.[appMode] || data?.cta?.link;

  return (
    <section className="container grid--default has-align-top hero--default lg:pb-10 md:ml-0 md:mr-0">
      <article className="text-left lg:maxw-lg md:ml-2.5 md:mr-2.5">
        <h1
          className="text-xl lg:pt-5"
          dangerouslySetInnerHTML={{ __html: data.title }}
        />
        {Array.isArray(data.desc) &&
          data.hasOwnProperty("desc") &&
          data.desc.map((item, index) => {
            return (
              <p
                className="lg:maxw-md lg:mt-2 lg:mb-2"
                key={index}
                dangerouslySetInnerHTML={{ __html: item }}
              />
            );
          })}
        {data.hasOwnProperty("cta") && (
          <div className="lg:mt-5 md:mt-2.5">
            <a href={signupLink} className="btn-primary">
              <span dangerouslySetInnerHTML={{ __html: data.cta.text }} />
            </a>
          </div>
        )}
        {data.hasTpWidget && (
          <TpWidgetMicro
            className={`lg:mt-5 md:mt-3 md:pt-2 ${data.cta ? "" : "md:ml-0"}`}
          />
        )}
      </article>{" "}
      <figure className="md:mt-5 md:mb-3">
        <picture>
          <AdaptiveCriticalImage
            src={data.image.src}
            alt={data.image.alt}
            mobile={data.image.prefixes.mobile}
            dpi={data.image.prefixes.dpi}
            dimensions={data.image.dimensions}
            className="lg:ml-2 md:w-100 imgholder-senary"
          />
        </picture>
        <style global jsx>
          {`
            @media (min-width: ${viewport.desktop.sm}) {
              .imgholder-senary {
                height: auto;
                width: 760px;
                margin-left: -80px !important;
                object-fit: initial;
              }
            }
          `}
        </style>
      </figure>
    </section>
  );
}
